import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { getIdentityPendingGetProgress } from 'store/entities/identity/selectors'
import { getIdentityProgress } from 'store/entities/identity/actions'
import OnBoardingSelectProtrack from './OnBoardingSelectProtrack'

const mapStateToProps = createStructuredSelector({
  // ToDo: keeping it for future task with adding loader to this screen
  isLoading: getIdentityPendingGetProgress,
})

const mapDispatchToProps = {
  getIdentityProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(OnBoardingSelectProtrack)
